
import { CustomForms } from 'src/app/components/forms/custom-forms';
import { AfterViewInit, Component, ElementRef, OnInit, signal, ViewChild } from '@angular/core';
import { AccionModel } from 'src/app/services/auditoria/models/accion.model';
import { UserLangService } from 'src/app/services/common/user-lang/user-lang.service';
import { JqWidgets } from 'src/app/utils/jqWidgets';
import { environment } from 'src/environments/environment';
import { HeaderComponent } from '../../header/header.component';
import { ElemInstalacionModel } from 'src/app/services/elements/models/instalacion/elem-instalacion.model';
import { AppComponent } from 'src/app/app.component';
import { InstalacionService } from 'src/app/services/elements/instalacion/instalacion.service';
import { Utils } from 'src/app/utils/utils';
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';
import * as xlsx from 'xlsx';
import { DateUtils } from 'src/app/utils/date-utils';
import { jqxDateTimeInputComponent } from 'jqwidgets-ng/jqxdatetimeinput';
import { WindowComponent } from 'movisat-common-gui';

@Component({
  selector: 'app-element-list-install',
  templateUrl: './element-list-install.component.html',
  styleUrls: ['./element-list-install.component.css']
})
export class ElementListInstallComponent implements OnInit, AfterViewInit {

  public langGrid = JqWidgets.getLocalization('es');
  public accion: AccionModel = new AccionModel();
  private componentRef = null;

  @ViewChild('gridListInstall') private gridListInstall: jqxGridComponent;
  @ViewChild('windowsListInstall') public windowsListInstall: WindowComponent;
  @ViewChild('header') private header: HeaderComponent;

  private instalaciones: ElemInstalacionModel[] = [];
  protected countPartialResults = signal<number>(0);
  protected titleWindow = this.translate('Listado_instalaciones');
  protected isLoading: boolean = true;
  protected columns: any[] = [];
  public static _this: ElementListInstallComponent;
  public theme = environment.tema;

  cellClass = (row: number, columnfield: any, value: any, data: any): string => {
    const classes = ['cellTooltip'];
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const nsCerraduraVacia = !data.nsCerradura?.trim();
    const sinFechaConexion = !data.fechaUltimaConexion;
    const fechaConexionAntigua = data.fechaUltimaConexion && new Date(data.fechaUltimaConexion) < today;

    if (nsCerraduraVacia) {
      classes.push('has-error');
      if (columnfield === 'nsCerradura') {
        classes.push('cell-with-errors');
      }
    } else if (sinFechaConexion) {
      classes.push('has-error');
      if (columnfield === 'fechaUltimaConexion') {
        classes.push('cell-with-errors');
      }
    } else if (fechaConexionAntigua) {
      classes.push('has-warning');
      if (columnfield === 'fechaUltimaConexion') {
        classes.push('cell-with-errors');
      }
    }

    return classes.join(' ');
  };

  incidenciasRenderer = (row: number, columnfield: string, value: boolean): string => {
    if (value) {
      return '<img style="margin-left: 4px; margin-top: 2px;" height="24" width="24" src="assets/images/report.png"/>';
    } else {
      return '';
    }
  };

  protected actions = [
    {type: "button", action:"salir", value: "", label: this.translate('Salir')}
  ];

  public actionButtonClicked(event): void {
    if(event.action === 'salir') {
      this.windowsListInstall.closeWindow();
      return;
    }
  }

  private loadTooltips = (columns: any[]): void => {
    columns.forEach(column => {
      column.rendered = (element) => { Utils.tooltiprenderer(element) };
    });

    columns.map(col => ({
      ...col,
      cellclassname: this.cellClass
    }));

  };

  protected dataSource = {
    datatype: 'json',
    datafields: [
      { name: 'fechaOperacion', type: 'date', map: 'fechaOperacion' },
      { name: 'horaOperacion', type: 'date', map: 'fechaOperacion' },
      { name: 'nsMovisat', type: 'string', map: 'nsMovisat' },
      { name: 'nsCerradura', tyope: 'string', map: 'nsCerradura' },
      { name: 'nombreElemento', type: 'string', map: 'nombreElemento' },
      { name: 'fechaUltimaConexion', type: 'date', map: 'fechaUltimaConexion' },
      { name: 'horaUltimaConexion', type: 'date', map: 'fechaUltimaConexion' },
      { name: 'nombreCortoEmpleado', type: 'string', map: 'nombreCortoEmpleado' },
      { name: 'municipio', type: 'string', map: 'municipio' },
      { name: 'provincia', type: 'string', map: 'provincia' },
      { name: 'estadoInstalacion', type: 'string', map: 'estadoInstalacion' },
      { name: 'incidencias', type: 'boolean', map: 'incidencias' },
      { name: 'selec', tyoe: 'string', map: 'selec' }
    ],
    localdata: [],
    sortcolumn: 'fechaOperacion',
    sortdirection: 'desc'
  };
  protected dataAdapter = new jqx.dataAdapter(this.dataSource);

  public constructor(private userLangService: UserLangService, private instalacionService: InstalacionService) {
    ElementListInstallComponent._this = this;
  }

  public ngOnInit(): void {
    this.langGrid = JqWidgets.getLocalization(this.userLangService.getUserLangShort());
    this.loadColumnsGrids();
  }

  init(componentRef: any) {
    this.componentRef = componentRef;
  }

  public async ngAfterViewInit(): Promise<void> {
    await this.loadGridData();
  }

  public columnmenuopening(menu?: any, datafield?: any, height?: number | string): boolean | void {
    if (!menu || menu.length !== 1 || !datafield) {
      return;
    }

    const dateTimeConfig: { [key: string]: { showTimeButton: boolean; showCalendarButton: boolean; formatString: string } } = {
      'fechaInstalacion': { showTimeButton: false, showCalendarButton: true, formatString: 'dd/MM/yyyy' },
      'fechaUltimaConexion': { showTimeButton: false, showCalendarButton: true, formatString: 'dd/MM/yyyy' },
      'horaInstalacion': { showTimeButton: true, showCalendarButton: false, formatString: 'HH:mm:ss' },
      'horaUltimaConexion': { showTimeButton: true, showCalendarButton: false, formatString: 'HH:mm:ss' },
    };

    if (!dateTimeConfig[datafield]) {
      return;
    }

    const configureDateTimeInput = (menuElement: HTMLElement, options: { showTimeButton: boolean; showCalendarButton: boolean, formatString: string }) => {
      if (!menuElement) return;

      const dateTimeInputs = menuElement.querySelectorAll('.jqx-datetimeinput');
      dateTimeInputs.forEach((input: HTMLElement) => {
        const elementRef = new ElementRef(input);
        const jqxDateTimeInput = new jqxDateTimeInputComponent(elementRef);
        const inputDate = jqwidgets.createInstance(`#${jqxDateTimeInput.elementRef.nativeElement.id}`, 'jqxDateTimeInput', {
          width: '100%', height: 25
        });
        inputDate.setOptions(options);
      });
    };

    const divElement: HTMLElement = menu[0];
    configureDateTimeInput(divElement, dateTimeConfig[datafield]);
  }

  loadColumnsGrids(): void {
    this.columns = [
      {
        text: this.translate('Fecha_operacion'),
        datafield: 'fechaOperacion',
        width: 100,
        type: 'string',
        filtertype: 'date',
        columntype: 'datetimeinput',
        cellsformat: 'dd/MM/yyyy',
        cellclassname: this.cellClass
      },
      {
        text: this.translate('Hora_operacion'),
        datafield: 'horaOperacion',
        width: 100,
        type: 'date',
        filtertype: 'date',
        columntype: 'datetimeinput',
        cellsformat: 'HH:mm:ss',
        cellclassname: this.cellClass
      },
      {
        text: this.translate('Ns_movisat'),
        datafield: 'nsMovisat',
        width: 100,
        type: 'string',
        filtertype: 'string',
        columntype: 'string',
        cellclassname: this.cellClass
      },
      {
        text: this.translate('Ns_cerradura'),
        datafield: 'nsCerradura',
        width: 100,
        type: 'string',
        filtertype: 'string',
        columntype: 'string',
        cellclassname: this.cellClass
      },
      {
        text: this.translate('Nombre_elemento'),
        datafield: 'nombreElemento',
        width: 200,
        columntype: 'string',
        cellclassname: this.cellClass
      },
      {
        text: this.translate('Fecha_ultima_conexion'),
        datafield: 'fechaUltimaConexion',
        width: 125,
        type: 'string',
        filtertype: 'date',
        columntype: 'datetimeinput',
        cellsformat: 'dd/MM/yyyy',
        cellclassname: this.cellClass
      },
      {
        text: this.translate('Hora_ultima_conexion'),
        datafield: 'horaUltimaConexion',
        width: 100,
        type: 'date',
        filtertype: 'date',
        columntype: 'datetimeinput',
        cellsformat: 'HH:mm:ss',
        cellclassname: this.cellClass
      },
      {
        text: this.translate('Nombre_corto_empleado'),
        datafield: 'nombreCortoEmpleado',
        width: 200,
        columntype: 'string',
        cellclassname: this.cellClass
      },
      {
        text: this.translate('Municipio'),
        datafield: 'municipio',
        width: 100,
        type: 'string',
        filtertype: 'checkedlist',
        cellclassname: this.cellClass
      },
      {
        text: this.translate('Provincia'),
        datafield: 'provincia',
        width: 100,
        columntype: 'string',
        filtertype: 'checkedlist',
        cellclassname: this.cellClass
      },
      {
        text: this.translate('Estado_instalacion'),
        datafield: 'estadoInstalacion',
        width: 140,
        columntype: 'string',
        filtertype: 'checkedlist',
        cellclassname: this.cellClass
      },
      {
        text: this.translate('Incidencias'),
        datafield: 'incidencias',
        width: 100,
        columntype: 'image',
        filtertype: 'checkedlist',
        cellsrenderer: this.incidenciasRenderer,
        filteritems: [this.translate('SI'), this.translate('NO')],
        cellclassname: this.cellClass
      },
      { text: 'selec', datafield: 'selec', hidden: true }
    ];
    this.loadTooltips(this.columns);
  }

  private async loadGridData(): Promise<void> {
    this.isLoading = true;
    this.instalaciones = await this.instalacionService.getInstalaciones();
    this.dataSource.localdata = this.instalaciones;
    this.gridListInstall.updatebounddata();
    this.gridListInstall.sortby('fechaInstalacion', 'desc');
  }

  protected onGridDataUpdate(): void {
    this.countPartialResults.set(this.gridListInstall.getrows().length);
    this.isLoading = false;
  }

  public filter(cellValue?: any, rowData?: any, dataField?: string, filterGroup?: any, defaultFilterResult?: boolean): any {

    if (dataField === "incidencias") {
      const filters = filterGroup.getfilters();
      for (let i = 0; i < filters.length; i++) {
        const filter = filters[i];
        if (filter.value === AppComponent.translate('SI')) {
          return rowData.incidencias;
        }
        else if (filter.value === AppComponent.translate('NO')) {
          return !rowData.incidencias;
        }
      }
    } else {
      const filterColumns = [
        'fechaInstalacion',
        'nsCerradura',
        'nombreElemento',
        'nombreCortoEmpleado',
        'municipio',
        'provincia',
        'estado',
        'incidencias',
        'selec',
        'fechaUltimaConexion',
        'horaUltimaConexion',
        'nsMovisat'
      ];

      return Utils.filterRow(cellValue, dataField, filterGroup, defaultFilterResult, filterColumns);
    }
  }

  protected onBuscar(): void {
    const filterValue = this.header.searchInput['nativeElement'].value.length >= 3
      ? this.header.searchInput['nativeElement'].value.toUpperCase()
      : '';

    const applyFilterToAllColumns = (grid: jqxGridComponent, data: any[]) => {
      if (filterValue) {
        data.forEach((row) => {
          const matchesSearch = Object.values(row).some(
            (value) => value !== undefined && value !== null && String(value).toUpperCase().includes(filterValue)
          );
          row['selec'] = matchesSearch ? 'selec' : '';
        });
        this.__ensureGridFiltersAreRegistered(grid);
        this.__tirggerGridFilters(grid);
      } else {
        grid.clearfilters();
        grid.updatebounddata('data');
      }
    };

    const instalaciones = this.instalaciones;
    applyFilterToAllColumns(this.gridListInstall, instalaciones);
    this.countPartialResults.set(this.gridListInstall.getrows().length);
  }

  private __ensureGridFiltersAreRegistered(grid: jqxGridComponent): void {
    const filters = grid.getfilterinformation();
    if (!filters.some(filter => filter.datafield === 'selec')) {
      const filtergroup = new jqx.filter();
      filtergroup.operator = 'and';

      const filter = filtergroup.createfilter('stringfilter', 'selec', 'contains');
      filtergroup.addfilter(0, filter);
      grid.addfilter('selec', filtergroup);
    }
  }

  private __tirggerGridFilters(grid: jqxGridComponent): void {
    grid.applyfilters();
    grid.updatebounddata('data');
  }

  public exportToExcel(): void {
    if (this.gridListInstall.getrows().length === 0) {
      return;
    }

    const rawData = this.gridListInstall.getrows();
    const columnsToExclude = ['selec', 'uid', 'boundindex', 'uniqueid', 'visibleindex'];

    const cleanedData = rawData.map(row => {
      return Object.fromEntries(
        Object.entries(row)
          .filter(([key]) => !columnsToExclude.includes(key))
          .map(([key, value]) => {
            if (key === 'incidencias') {
              return [key, value === true ? this.translate('SI') : this.translate('NO')];
            }
            if (key === 'fechaOperacion' || key === 'fechaUltimaConexion') {
              return [key, value ? this.formatDate(value as string) : ''];
            }
            if (key === 'horaOperacion' || key === 'horaUltimaConexion') {
              return [key, value ? this.formatTime(value as string) : ''];
            }
            return [key, value ?? ''];
          })
      );
    });

    const ws: xlsx.WorkSheet = xlsx.utils.json_to_sheet(cleanedData);
    this.generateAutofilterHeader(ws);

    const wb: xlsx.WorkBook = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(wb, ws, 'Hoja1');
    xlsx.writeFile(wb, DateUtils.formatDateAMDhms(new Date()) + '_' + this.translate(this.titleWindow) + '.xlsx');
  }

  private formatDate(value: string | Date): string {
    const date = new Date(value);
    return date.toLocaleDateString('es-ES');
  }

  private formatTime(value: string | Date): string {
    const date = new Date(value);
    return date.toLocaleTimeString('es-ES');
  }

  private generateAutofilterHeader(sheet: any): void {
    sheet['!autofilter'] = { ref: sheet['!ref'] };
  }

  protected onFilter(): void {
    this.loadGridData();
  }

  protected onResetFilter(): void {
    this.gridListInstall.clearfilters();
    this.loadGridData();
  }

  public updatefilterconditions = (type: string, defaultconditions: any): string[] => {
    return Utils.updatefilterconditions(type, defaultconditions);
  };

  public translate(text: string): string {
    return AppComponent.translate(text);
  }

  protected onClose(): void {
    this.componentRef.destroy();
    ElementListInstallComponent._this = null;
  }
}
